import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
import store from '../../store'
import { qs, qsa } from '../../utils'
import DefaultRenderer from './Default'
Swiper.use([Navigation, Pagination, EffectFade, Autoplay])

class BlogRenderer extends DefaultRenderer {
  constructor(opts) {
    super(opts)
  }

  initRender() {
    // store.resizeFn = this.onResize.bind(this);
    store.resizeFn = null
    store.section = 'terms'
    this.slidePress()
    this.setUpVideo()
    this.setHeaderStyle('white')
    this.onPageChange()
    this.handleCTA()
  }

  onEnter() {
    super.onEnter()
    this._setIndividualBlogPageScreenName()
  }

  /**
   * Set the screen name for individual blog pages if the page is not the blog home page
   */
  _setIndividualBlogPageScreenName() {
    const url = new URL(window.location.href)
    if (url.pathname.split('/').length > 2) {
      this.screenName = `Website EarnIn dotcom - ${
        this.properties.page.title.split(' | ')[0]
      } Blog Page`
    }
  }

  onLeave() {
    super.onLeave()
  }

  onEnterCompleted() {
    super.onEnterCompleted()
    this.initRender()
  }

  onLeaveCompleted() {
    super.onLeaveCompleted()
  }

  handleCTA() {
    if (store.cta) {
      const blogCTA = qs('.blog-cta')
      if (blogCTA) blogCTA.style.display = 'block'
    }

    // Attach the click event to the document body (or some other parent that's always in the DOM)
    document.body.addEventListener('click', function (event) {
      // Check if the clicked element or its parent has the 'blog-cta-close' class
      if (event.target.closest('.blog-cta-close')) {
        store.cta = false
        qs('.blog-cta').style.display = 'none'
      }
    })
  }

  setUpVideo() {
    const $parent = qsa('.video-mask')

    $parent.forEach(($mask) => {
      const $iframe = qs('iframe', $mask)
      const $trigger = qs('img', $mask)
      $trigger.addEventListener('click', () => {
        $iframe.src += '?autoplay=1&showinfo=0&controls=1&disablekb=1'
        $mask.classList.add('active')
      })
      const $svg = qs('.play', $mask)
      $svg.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          $trigger.click()
        }
      })
    })
  }
  slidePress() {
    let autoplayObj = {
      autoplay: {
        delay: 4000,
        waitForTransition: true,
        disableOnInteraction: false,
      },
    }

    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

    if (!mediaQuery || mediaQuery.matches) {
      autoplayObj.autoplay = false
    }
    const homeSlideLinks = new Swiper('#hero-links-slide', {
      slidesPerView: 2,
      // spaceBetween: 100,
      centeredSlides: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      loop: true,
      speed: 1000,
      ...autoplayObj,
    })
  }
}

export default BlogRenderer
